export const TIME_RANGE = [
  { label: "Last 5 minutes", value: "-5m" },
  { label: "Last 15 minutes", value: "-15m" },
  { label: "Last 1 hour", value: "-1h" },
  { label: "Last 6 hours", value: "-6h" },
  { label: "Last 24 hours", value: "-24h" },
  { label: "Last 7 days", value: "-7d" },
  { label: "Custom", value: "custom" },
];
